export default "__VITE_ASSET__CCfv_Uhc__"